import { CHANGE_BI_MODEL_PROPS } from "../actions/ActionConstants";

const current_year = new Date().getFullYear();
const current_month = new Date().getMonth() + 1;

const initialState = {
	year: current_year,
	month: current_month,
	homeStats: [],
	childrenStats: {},
	selectedProvinces: {},
	selectedCities: {}
};

export default function BIModuleReducer(state = initialState, action) {
	switch (action.type) {
		case CHANGE_BI_MODEL_PROPS:
			return Object.assign({}, state, action.props);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/BIModuleReducer.js